import { useEffect, useState } from 'react'
import { formatSocialStat } from '../lib/formatSocialStat'

const DURATION_MS = 1500

const easeOutExpo = (progress) =>
  progress >= 1 ? 1 : 1 - Math.pow(2, -10 * progress)

const AnimatedSocialStat = ({ value, animateKey, delayMs = 0 }) => {
  const [displayValue, setDisplayValue] = useState(0)

  useEffect(() => {
    if (value == null) return undefined

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (prefersReducedMotion) {
      setDisplayValue(value)
      return undefined
    }

    let rafId = 0
    let timeoutId = 0
    let startTime = 0

    const tick = (timestamp) => {
      if (!startTime) startTime = timestamp

      const elapsed = timestamp - startTime
      const progress = Math.min(1, elapsed / DURATION_MS)
      const eased = easeOutExpo(progress)

      setDisplayValue(Math.round(value * eased))

      if (progress < 1) {
        rafId = requestAnimationFrame(tick)
      }
    }

    setDisplayValue(0)
    timeoutId = window.setTimeout(() => {
      rafId = requestAnimationFrame(tick)
    }, delayMs)

    return () => {
      window.clearTimeout(timeoutId)
      cancelAnimationFrame(rafId)
    }
  }, [value, animateKey, delayMs])

  if (value == null) return 'N/A'

  return formatSocialStat(displayValue)
}

export default AnimatedSocialStat
